(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/app/app.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/app/app.js');

(function(svs) {
  'use strict';

  svs.matchen = svs.matchen || {};

  svs.matchen.App = Marionette.Application.extend({
    region: '#matchen',

    onBeforeStart: function() {
      this.logger = new svs.core.log.Logger('matchen:app');
      svs.matchen.router = new svs.matchen.Router();
    },

    onStart: function() {
      this.skeleton = new svs.matchen.views.Skeleton();
      this.showView(this.skeleton);

      if (!Backbone.History.started) {
        Backbone.history.start({
          pushState: Modernizr.history,
          root: svs.core.data.baseUrl
        });
      }
    }
  });

  svs.matchen.app = new svs.matchen.App();
})(svs);


 })(window);